export default __webpack_public_path__ + "static/media/about-us.0a746c3b.svg";